import type { ReferenceType } from '@cult/domain';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { ReferenceDataTabs, visibleReferenceTypes } from '../../../../features/admin/reference';
import { useCurrentUser } from '../../../../state/use-current-user';

const ReferenceDataPage = () => {
  const { type } = Route.useParams();
  return <ReferenceDataTabs type={type as ReferenceType} />;
};

export const Route = createFileRoute('/_auth/admin/reference/$type')({
  // An unknown type, or one the role can't see (an idea manager on core values), falls back to the first tab.
  beforeLoad: ({ params }) => {
    const role = useCurrentUser.getState().user?.role;
    const visible: string[] = role ? visibleReferenceTypes(role) : [];
    if (!visible.includes(params.type)) throw redirect({ to: '/admin/reference' });
  },
  component: ReferenceDataPage,
});
